export default function truncate(str, n = 18) {
  if (str.length > n) {
    return `${str.substr(0, n - 8)}...${str.substr(str.length - 8)}`
  } else {
    return str
  }
}



// WEBPACK FOOTER //
// ./src/functions/truncate.js